import { render } from "./GoogleChrome.svg?vue&type=template&id=ece99c46"
const script = {}
script.render = render

export default script